import wx from 'weixin-js-sdk'
import myBMap from '@/utils/myBMap';
import {loginAuth} from "../api/common";
export function getToken() {
  return localStorage.getItem('token')
}
export function getUserInfo() {
  let userInfo = {
    nick_name:localStorage.getItem('nick_name'),
    avatar_url:localStorage.getItem('avatar_url'),
    grade:localStorage.getItem('grade'),
    user_id:localStorage.getItem('user_id'),
    id_card:localStorage.getItem('id_card')
  }
  return userInfo
}

export function setUserInfo(data) {
  localStorage.setItem('nick_name',data['nick_name'])
  localStorage.setItem('avatar_url',data['avatar_url'])
  localStorage.setItem('grade',data['grade'])
  localStorage.setItem('user_id',data['user_id'])
  localStorage.setItem('id_card',data['id_card'])
}


export function throttle (fn, delay = 100) {
  let timer = null
  console.log(timer)
  return function () {
    if (timer) return
    timer = setTimeout(() => {
      fn.apply(this, arguments)
      timer = null
    }, delay)
  }
}

export function getStatus(val) {
  switch (val) {
    case 10:
      val = '预招募'
      break;
    case 20:
      val = '进行中'
      break;
    case 30:
      val = '已招满'
      break;
    case 40:
      val = '项目延期'
      break;
    case 50:
      val = '项目暂停'
      break;
    case 60:
      val = '项目关闭'
      break;
      case 60:
        val = '项目关闭'
        break;
        case 80:
          val = '项目完结'
          break;
  }
  return val
}

export function getStatusColor(val) {
  switch (val) {
    case 10:
      val = 'color:#7198F3'
      break;
    case 20:
      val = 'color:#57CAC6'
      break;
    case 30:
      val = 'color:#F25555'
      break;
    case 40:
      val = 'color:#22C282'
      break;
    case 50:
      val = 'color:#FD7676'
      break;
    case 60:
      val = 'color:#FEBB36'
      break;
    case 80:
        val = 'color:#57CAC6'
        break;
  }
  return val
}

export function getStatusRec(val) {
  switch (val) {
    case 10:
      val = '只招男'
      break;
    case 20:
      val = '只招女'
      break;
    case 30:
      val = '男满招女'
      break;
    case 40:
      val = '女满招男'
    case 50:
      val = '男女均可'
      break;
  }
  return val
}

export function getStatusRecColor(val) {

  switch (val) {
    case 10:
      val = 'background-color: #5584F2;'
      break;
    case 20:
      val = 'background-color: #FF7676;'
      break;
    case 30:
      val = 'background-color: #FF8A8A;'
      break;
    case 40:
      val = 'background-color: #7198F3;'
    case 50:
      val = 'background-color: #eeeeee;'
      break;
  }
  return val
}

export function getStatusRecColorz(val) {

  switch (val) {
    case 10:
      val = 'color: #5584F2;'
      break;
    case 20:
      val = 'color: #FF7676;'
      break;
    case 30:
      val = 'color: #FF8A8A;'
      break;
    case 40:
      val = 'color: #7198F3;'
      break;
  }
  return val
}
function add0(m){return m<10?'0'+m:m }
export function getTime(val){
  let time = new Date(val*1000);
  let y = time.getFullYear();
  let m = time.getMonth()+1;
  let d = time.getDate();
  let h = time.getHours();
  let mm = time.getMinutes();
  let s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
  return y+'-'+add0(m)+'-'+add0(d);
}
export function getTimeTwo(val){
  let time = new Date(val*1000);
  let y = time.getFullYear();
  let m = time.getMonth()+1;
  let d = time.getDate();
  let h = time.getHours();
  let mm = time.getMinutes();
  let s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);

  return y+'-'+add0(m)+'-'+add0(d)+'号 '+parseInt(add0(h))+'点';
}

export function compress(img, name,type) {
  let canvas = document.createElement('canvas')
  let ctx = canvas.getContext('2d')
  //瓦片canvas
  let tCanvas = document.createElement('canvas')
  let tctx = tCanvas.getContext('2d')
  // let initSize = img.src.length;
  let width = img.width
  let height = img.height
  //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
  let ratio
  if ((ratio = (width * height) / 4000000) > 1) {
    // console.log("大于400万像素");
    ratio = Math.sqrt(ratio)
    width /= ratio
    height /= ratio
  } else {
    ratio = 1
  }
  canvas.width = width
  canvas.height = height
  //    铺底色
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  //如果图片像素大于100万则使用瓦片绘制
  let count
  if ((count = (width * height) / 1000000) > 1) {
    // console.log("超过100W像素");
    count = ~~(Math.sqrt(count) + 1) //计算要分成多少块瓦片
    //      计算每块瓦片的宽和高
    let nw = ~~(width / count)
    let nh = ~~(height / count)
    tCanvas.width = nw
    tCanvas.height = nh
    for (let i = 0; i < count; i++) {
      for (let j = 0; j < count; j++) {
        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
      }
    }
  } else {
    ctx.drawImage(img, 0, 0, width, height)
  }
  //进行最小压缩
  let ndata = canvas.toDataURL('image/jpeg', 0.1)
  tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
  return dataURLtoFile(ndata, name,type)
}

//将base64转换为文件
function dataURLtoFile(dataurl, name,type) {
  var arr = dataurl.split(','),
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], name, {
    type: type
  })
}
export async function initWxShareTwo(call){
  let res = await loginAuth({url: encodeURIComponent(location.href.split('#')[0])});
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: res.data.appId, // 必填，公众号的唯一标识
    timestamp:res.data.timestamp, // 必填，生成签名的时间戳
    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    signature: res.data.signature,// 必填，签名
    jsApiList: ['openLocation','getLocation','onMenuShareTimeline', 'onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo','updateAppMessageShareData','updateTimelineShareData'] // 必填，需要使用的JS接口列表
  });
  wx.ready(() => {
    call();
  })
}

export async function initWxShare(){

  let res = await loginAuth({url: encodeURIComponent(location.href)});
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: res.data.appId, // 必填，公众号的唯一标识
    timestamp:res.data.timestamp, // 必填，生成签名的时间戳
    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    signature: res.data.signature,// 必填，签名
    jsApiList: ['openLocation','getLocation','onMenuShareTimeline', 'onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo','updateAppMessageShareData','updateTimelineShareData'] // 必填，需要使用的JS接口列表
  });
  //,'onMenuShareTimeline', 'onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo','updateAppMessageShareData','updateTimelineShareData'
  setShare();
}
export function restShare(title,desc,image,furl){
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      link: furl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: image, // 分享图标
      success: function () {
        // 用户点击了分享后执行的回调函数
      }
    })
    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: furl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: image, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        // 用户点击了分享后执行的回调函数
      }
    })
    wx.onMenuShareQQ({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: furl, // 分享链接
      imgUrl: image, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })
    wx.onMenuShareWeibo({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: furl, // 分享链接
      imgUrl: image, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })
    wx.updateTimelineShareData({
      title: title, // 分享标题
      link: furl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: image, // 分享图标
      success: function () {
        // 设置成功
      }
    })
    wx.updateAppMessageShareData({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: furl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: image, // 分享图标
      success: function () {
        // 设置成功
      }
    })
}
function setShare(){
  wx.ready(() => {
    wx.onMenuShareTimeline({
      title: '无忧试药在线报名平台', // 分享标题
      link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://www.usababyinfo.com/wysy/static/img/logo.f4fa8f5.png', // 分享图标
      success: function () {
        // 用户点击了分享后执行的回调函数
      }
    })
    wx.onMenuShareAppMessage({
      title: '无忧试药在线报名平台', // 分享标题
      desc: '广州美瑛荟医学科技有限公司是一家专注于药物临床试验招募的服务机构，美瑛荟目前运营着业内知名的志愿者招募服务平台『无忧试药』。', // 分享描述
      link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://www.usababyinfo.com/wysy/static/img/logo.f4fa8f5.png', // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        // 用户点击了分享后执行的回调函数
      }
    })
    wx.onMenuShareQQ({
      title: '无忧试药在线报名平台', // 分享标题
      desc: '广州美瑛荟医学科技有限公司是一家专注于药物临床试验招募的服务机构，美瑛荟目前运营着业内知名的志愿者招募服务平台『无忧试药』。', // 分享描述
      link: location.href, // 分享链接
      imgUrl: 'https://www.usababyinfo.com/wysy/static/img/logo.f4fa8f5.png', // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })
    wx.onMenuShareWeibo({
      title: '无忧试药在线报名平台', // 分享标题
      desc: '广州美瑛荟医学科技有限公司是一家专注于药物临床试验招募的服务机构，美瑛荟目前运营着业内知名的志愿者招募服务平台『无忧试药』。', // 分享描述
      link: location.href, // 分享链接
      imgUrl: 'https://www.usababyinfo.com/wysy/static/img/logo.f4fa8f5.png', // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })
    wx.updateTimelineShareData({
      title: '无忧试药在线报名平台', // 分享标题
      link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://www.usababyinfo.com/wysy/static/img/logo.f4fa8f5.png', // 分享图标
      success: function () {
        // 设置成功
      }
    })
    wx.updateAppMessageShareData({
      title: '无忧试药在线报名平台', // 分享标题
      desc: '广州美瑛荟医学科技有限公司是一家专注于药物临床试验招募的服务机构，美瑛荟目前运营着业内知名的志愿者招募服务平台『无忧试药』。', // 分享描述
      link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://www.usababyinfo.com/wysy/static/img/logo.f4fa8f5.png', // 分享图标
      success: function () {
        // 设置成功
      }
    })
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        myBMap.init().then(BMap=>{
          let gc = new BMap.Geocoder();
          let pointAdd = new BMap.Point(res.longitude, res.latitude);
          gc.getLocation(pointAdd, function(rs){
            localStorage.setItem('city',rs.addressComponents.city)
          })
        })
      },
      cancel:function (res) {
        localStorage.setItem('dw','111')
      }
    })
  });
}



// WEBPACK FOOTER //
// ./src/utils/auth.js